module.exports = __webpack_public_path__ + "static/media/fungoxyl.6baa922e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/tizon_tardio_tomate/curativa/fungoxyl.png
// module id = 2397
// module chunks = 3